/**
 *
 * LERP
 * Linear interpolation
 *
 */
export function lerp(start, end, value) {
  return (1 - value) * start + value * end;
}

/**
 *
 * Linear interpolation on loopable angle
 * angle in radians
 *
 */
export function shortAngleDist(start, end) {
  var max = Math.PI * 2;
  var delta = (end - start) % max;
  return ((2 * delta) % max) - delta;
}

export function lerpAngle(start, end, value) {
  return start + shortAngleDist(start, end) * value;
}

/**
 *
 * BERP
 * Boing-like interpolation
 *
 */
export function berp(start, end, value) {
  value =
    (Math.sin(value * Math.PI * (0.2 + 2.5 * value * value * value)) *
      Math.pow(1 - value, 2.2) +
      value) *
    (1 + 1.2 * (1 - value));
  return start + (end - start) * value;
}

/**
 *
 * CLERP
 * Circular Lerp - is like lerp but
 * handles the wraparound from 0 to 360.
 *
 */
export function clerp(start, end, value) {
  const min = 0;
  const max = 360;
  const half = Math.abs((max - min) / 2);

  let retval = 0;
  let diff = 0;

  if (end - start < -half) {
    diff = (max - start + end) * value;
    retval = start + diff;
  } else if (end - start > half) {
    diff = -(max - end + start) * value;
    retval = start + diff;
  } else retval = start + (end - start) * value;

  return retval;
}

/**
 *
 * COSERP
 * Ease in.
 *
 */
export function coserp(start, end, value) {
  return lerp(start, end, 1 - Math.cos(value * Math.PI * 0.5));
}

/**
 *
 * HERMITE
 * Ease in out.
 *
 */
export function hermite(start, end, value) {
  return lerp(start, end, value * value * (3 - 2 * value));
}

/**
 *
 * SINERP
 * Ease out.
 *
 */
export function sinerp(start, end, value) {
  return lerp(start, end, Math.sin(value * Math.PI * 0.5));
}

/**
 *
 * SPRING
 *
 * const spring = new Spring(0.92, 30.0, 0.4);
 * const start = spring.update(start, end);
 *
 */
export class Spring {
  constructor(damp, mass, k) {
    this._damp = damp;
    this._mass = mass;
    this._k = k; // stiffness
    this._vel = 0; // velocity
  }

  update(start, end) {
    const force = -this._k * (start - end); // f=-ky
    const accel = force / this._mass; // Set the acceleration, f=ma == a=f/m
    this._vel = this._damp * (this._vel + accel); // Set the velocity
    return start + this._vel; // Updated position
  }
}
